import React, { Component } from "react";
import { connect } from "react-redux";
import {
  getTrackedWebsiteCompetitors,
  getSelectedWebsiteDomain,
  getSelectedWebsiteUrl,
  isAddingCompetitor,
  getCompetitorBeingDeleted,
} from "../../store/tracked_websites/selectors";
import { getMaxCompetitorsNo } from "../../store/sales/selectors";
import { updateSettings } from "../../store/tracked_websites/operations";
import CompetitorsTab from "../../components/DashboardSettings/CompetitorsTab";

export class Competitors extends Component {
  render() {
    return (
      <CompetitorsTab
        domain={this.props.domain}
        mainUrl={this.props.selectedTrackedUrl}
        competitors={this.props.competitors}
        maxCompetitorsNo={this.props.maxCompetitorsNo}
        isAddingCompetitors={this.props.isAddingCompetitors}
        updateCompetitors={this.props.updateSettings}
        competitorBeingDeleted={this.props.competitorBeingDeleted}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  domain: getSelectedWebsiteDomain(state),
  selectedTrackedUrl: getSelectedWebsiteUrl(state),
  maxCompetitorsNo: getMaxCompetitorsNo(state),
  competitors: getTrackedWebsiteCompetitors(state),
  isAddingCompetitors: isAddingCompetitor(state),
  competitorBeingDeleted: getCompetitorBeingDeleted(state),
});

export default connect(mapStateToProps, { updateSettings })(Competitors);
